import React, { useEffect, useState } from 'react'; 
import { Link } from 'react-router-dom';

import Header from "../Component/Header";
import AdminHeader from "../Component/AdminHeader";
import Footer from "../Component/Footer";
import { useContext } from 'react';
import { ArgContext } from '../../Context/ArgProvider';


// import required modules
//import Swiper from "swiper";
import "swiper/swiper-bundle.css"; 


import mainBg1 from "../../assets/img/mainBanner01.jpg";
import mainBg2 from "../../assets/img/mainBanner02.jpg";
import mainBg3 from "../../assets/img/mainBanner03.jpg";
import mainBg4 from "../../assets/img/mainBanner04.jpg";
import listImg1 from "../../assets/img/main-solution1.jpg";
import listImg2 from "../../assets/img/main-solution2.jpg";
import listImg3 from "../../assets/img/main-solution3.jpg";
import listImg4 from "../../assets/img/main-solution4.jpg";
import listImg5 from "../../assets/img/main-solution5.jpg";



function Main() {

	// 일반 또는 관리자 header 설정
	const { argInfo } = useContext(ArgContext);
  const isAdmin = argInfo?.role === 'admin';

	//  솔루션 리스트 활성화/애니메이션 상태
  const [activeIndex, setActiveIndex] = useState(null);
  const [animationClass, setAnimationClass] = useState("");
  const [isMobile, setIsMobile] = useState(false);
/*
	//swiper 슬라이드
	useEffect(() => {
		// DOM이 완전히 렌더링된 후 Swiper 초기화
		const timer = setTimeout(() => {
			const swiperElement = document.querySelector(".mainBanner-swiper");
			if (!swiperElement) return;

			// data-options에서 설정을 가져와서 Swiper 인스턴스 생성
			const options = JSON.parse(swiperElement.getAttribute("data-swiper-options"));
			
			// 페이지네이션 설정 강화
			options.pagination = {
				...options.pagination,
				clickable: true,
				renderBullet: function (index, className) {
					return '<span class="' + className + '"></span>';
				}
			};
			
			// 초기 슬라이드 설정
			options.initialSlide = 0;
			
			const swiper = new Swiper(swiperElement, options);
			
			// 첫 번째 슬라이드 활성화 강제
			swiper.slideTo(0, 0, false);
			
			return () => {
				if (swiper) {
					swiper.destroy(true, true);
				}
			};
		}, 100);

		return () => clearTimeout(timer);
	}, []);

		//  모바일 (480px 이하일 때 active 유지 & 클릭 비활성화)
	 	useEffect(() => {
			const checkMobile = () => setIsMobile(window.innerWidth <= 480);
			checkMobile();
			window.addEventListener("resize", checkMobile);
			return () => window.removeEventListener("resize", checkMobile);
		}, []);

*/


		//  li 클릭 이벤트 핸들러
		const handleClick = (index) => {
    if (isMobile) return;

    if (activeIndex === index) {
      setAnimationClass("fade-out-in");
      setTimeout(() => {
        setActiveIndex(null);
        setAnimationClass("");
      }, 400);
    } else {
      setAnimationClass("fade-in");
      setActiveIndex(index);
      setTimeout(() => setAnimationClass(""), 400);
    }
  };


    return (
        <>
	
	<main className="page-wrapper">
			{isAdmin ? <AdminHeader /> : <Header />}
			<section 
				className="swiper mainBanner-swiper"
				data-swiper-options={`{
					"loop": true,
					"autoplay": {
						"delay": 3000,
						"disableOnInteraction": false
					},
					"pagination": {
						"el": ".swiper-pagination",
						"clickable": true
					},
					"speed": 600
				}`}
			>
      <ul className="swiper-wrapper">
				<li className="swiper-slide" style={{ backgroundImage: `url(${mainBg4})` }}>
					<div className="bannerTxt">
						<h3 className="title">
							위피아의 AI 솔루션으로 <span className="blue">당신의 삶을 더 스마트하게</span>
						</h3>
						<p className="text">당신의 일상, 산업, 미래를 위한 AI. 정교한 설계와 직관적인 인터페이스로 누구나 쉽게, 누구보다 더 스마트하게 구성하였습니다.</p>
					</div>
				</li>
        <li className="swiper-slide" style={{ backgroundImage: `url(${mainBg1})` }}>
					<div className="bannerTxt">
						<h3 className="title">
							Private Data 기반의 <span className="blue">기업 맞춤형 sLLM 모델 구축</span>
						</h3>
						<p className="text">학습모델에 기업 사내 데이터나 문서를 활용해 정보유출방지 및 성능을 모두 갖춘 기업 맞춤형 AI 모델을 구축합니다</p>
					</div>
				</li>
        <li className="swiper-slide" style={{ backgroundImage: `url(${mainBg2})` }}>
					<div className="bannerTxt">
						<h3 className="title">
							기업 특화 AI Agent 를 활용한 <span className="blue">비즈니스 프로세스 자동화</span>
						</h3>
						<p className="text">고객의 질문에 즉각 응답, 맞춤형 제공까지 기업의 복잡한 업무를 독립적으로 수행하는 AI Agent 모델을 구축합니다</p>
					</div>
				</li>
        <li className="swiper-slide" style={{ backgroundImage: `url(${mainBg3})` }}>
					<div className="bannerTxt">
						<h3 className="title">
							다중 Agent & Private LLM <span className="blue">맞춤형 RAG 챗봇 개발</span>
						</h3>
						<p className="text">각 모델의 특성과 장점 향상시키는 것이며, 내·외부 데이터의 연계를 통해 더욱 신뢰성 높은 대응을 실현합니다</p>
					</div>
				</li>
      </ul>
      <div className="swiper-pagination"></div>
    </section>
			
		
		<section className="container-auto main-solution sec-my">
			<ul className="solution-list">
				<li className={`${(isMobile || activeIndex === 0) ? "active" : ""} ${!isMobile ? animationClass : ""}`}  onClick={() => handleClick(0)}>
					<div className="titWrap">
						<img src={listImg1} alt="인공지능(AI)" />
						<div className="txtBox">
							<h4 className="tit">인공지능(AI)</h4>
							<p className="txt">AI 대변혁의 시대, 인공지능 전환(AX)과 생성 AI 기술을 결합한 서비스 단위의 솔루션을 제공합니다.</p>
							<button className="more-btn">자세히 보기 +</button>
						</div>
					</div>
					<ul className="listBox">
						<li>AI 에이전트 (Agent), 생성형 AI 챗봇</li>
						<li>AI 검색증강생성 (RAG) 애플리케이션</li>
						<li>AI 통합검색, 벡터 검색 등 검색 포털</li>
						<li>NLP, LLM, SLM 애플리케이션</li>
						<li>AI Vision(영상분석, 이미지분석 등으로 객체인식, 위험상황 인식등)</li>
						<li>멀티모달</li>
						<li>빅데이터 데이터 수집/분류/처리</li>
						<li>AI OCR, 업무 RPA( 업무 자동화 )</li>
					</ul>
				</li>
				<li className={`${(isMobile || activeIndex === 1) ? "active" : ""} ${!isMobile ? animationClass : ""}`}  onClick={() => handleClick(1)}>
					<div className="titWrap">
						<img src={listImg2} alt="AIoT, Monitoring" />
						<div className="txtBox">
							<h4 className="tit">AIoT, Monitoring</h4>
							<p className="txt">필요한 기술 컨설팅을 제공하며, 고객의 요구사항에 맞춰 AIoT 서비스를 구축하여 현장의 모든 상황에 대한 실시간 이벤트 모니터링 및 대응으로 맞춤 고객경험을 제공합니다.</p>
							<button className="more-btn">자세히 보기 +</button>
						</div>
					</div>
					<ul className="listBox">
						<li>IOT 장치 시스템 구축</li>
						<li>IOT 센서 기술 : 온도,습도, 압력 , 조도, 가속도, 자이로 센서,  GPS, GIS, ADAS, DTG, CCTV 등</li>
						<li>데이터 수집 및 전송기술 : 이더넷, RS232,RS485, Wi-FI, BLE, RFID/NFC, Zigbee, 4G/5G, NB-IOT, LoRa 등의 IOT Gateway</li>
						<li>맞춤형 IoT 애플리케이션 개발 : 공공, 생활, 안전, 복지, 물류/유통등의  문제 해결을 위한 AIoT 플랫폼 개발구축</li>
						<li>건설/시설물, 산업안전, 환경/재난/재해등  AIoT 서비스 개발 구축</li>
						<li>AIoT 데이터 학습/분석으로 상황인식, 행동예측  및 시각화 제공</li>
					</ul>
				</li>
				<li className={`${(isMobile || activeIndex === 2) ? "active" : ""} ${!isMobile ? animationClass : ""}`}  onClick={() => handleClick(2)}>
					<div className="titWrap">
						<img src={listImg3} alt="위치기반서비스(Location Based Service, LBS) 개발 제공 " />
						<div className="txtBox">
							<h4 className="tit">위치기반서비스 </h4>
							<p className="txt">GIS,GPS, 휴대폰 위치를 이용하여 다양한 위치 기반 관제 서비스 솔루션을 제공합니다.</p>
							<button className="more-btn">자세히 보기 +</button>
						</div>
					</div>
					<ul className="listBox">
						<li>위치기반 생활편의 앱 구축, 고객 맞춤형 서비스 구축</li>
						<li>긴급 구조요청, 위험지역 경고등 안전 관련 모니터링 및 관제 서비스</li>
						<li>실시간 교통정보, 모빌리티 위치 추적 및 관제 서비스,보험사 긴급출동 서비스</li>
						<li>물류 수배송 시스템 , 화물추적, FMS(차량관제 서비스), 콜드체인 물류관제 서비스</li>
						<li>탱크로리 관제, 고속/직행버스 관제, 셔틀버스 관제, 스마트 가로등</li>
						<li>운전자 안전 위험상황 인지 서비스,  안심귀가 서비스, 개인 이동장치 신고 시스템 등</li>
					</ul>
				</li>
				<li className={`${(isMobile || activeIndex === 3) ? "active" : ""} ${!isMobile ? animationClass : ""}`}  onClick={() => handleClick(3)}>
					<div className="titWrap">
						<img src={listImg4} alt="모바일 애플리케이션" />
						<div className="txtBox">
							<h4 className="tit">모바일 애플리케이션 </h4>
							<p className="txt">Web, Hybrid, native 등 다양한 플랫폼 환경을 제공합니다.</p>
							<button className="more-btn">자세히 보기 +</button>
						</div>
					</div>
					<ul className="listBox">
						<li>크로스 플랫폼 앱 구축</li>
						<li>네이티브 앱 구축</li>
						<li>고객 맞춤형 특화 모바일 서비스 구축</li>
						<li>하이브리드 앱 구축 </li>
					</ul>
				</li>
				<li className={`${(isMobile || activeIndex === 4) ? "active" : ""} ${!isMobile ? animationClass : ""}`} onClick={() => handleClick(4)}>
					<div className="titWrap">
						<img src={listImg5} alt="웹 시스템 개발제공" />
						<div className="txtBox">
							<h4 className="tit">웹 시스템 개발제공</h4>
							<p className="txt">브랜드 가치와 사용자 경험을 중심으로 고객 맞춤형 비즈니스 및 서비스 플랫폼을 제공합니다.</p>
							<button className="more-btn">자세히 보기 +</button>
						</div>
					</div>
					<ul className="listBox">
						<li>비즈니스 플랫폼 구축</li>
						<li>서비스 플랫폼 구축</li>
						<li>전자상거래 구축</li>
						<li>데이터 포털 구축</li>
						<li>반응형 웹사이트 구축</li>
						<li>콘텐츠 관리 시스템 구축</li>
					</ul>
				</li>
			</ul>
		</section>

    
		</main>
	<Footer />
	
        </>
    )
}

export default Main;